import { OCDocTypeOCR, PassportOCRResponse } from '@/shared/types/api.types'
import HttpService from '../HttpService'
import { DefaultResponse } from '@/shared/types/response.types'

export class OcrService extends HttpService {
  async passportOCR(
    file: File,
    docType: OCDocTypeOCR,
    abortController?: AbortController
  ): Promise<PassportOCRResponse> {
    const formData = new FormData()

    formData.append('file', file)
    formData.append('docType', docType)
    const { data } = await this.post<DefaultResponse & { passport: PassportOCRResponse }>(
      'passport-ocr',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        signal: abortController?.signal,
      }
    )
    return data.passport
  }
}
